import React from 'react';
import './TableSearch.css';

function TableSearch({ value, onChange, placeholder }) {
  return (
    <div className="table-search-container">
      <input
        type="text"
        className="table-search-input"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder || 'Buscar...'}
        aria-label="Buscar"
      />
      <svg className="table-search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
    </div>
  );
}

export default TableSearch;
